import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 船舶监控分享记录
 */
class SharingValidity extends UltMeta {
    SEVEN = new Meta(1, "7天");
    THIRTY = new Meta(2, "30天");
    NINETY = new Meta(3, "90天");
    PERMANENT = new Meta(4, "永久");
}
export const SHARING_VALIDITY = new SharingValidity();
